import { Timestamp } from 'firebase/firestore';
import { FaPlay } from 'react-icons/fa';
import { toast, ToastContainer } from 'react-toastify';
import { getDocument, updateDocument } from '../../firebase-functions/database';
import { auth } from '../../firebase-functions/config';
import { p } from 'framer-motion/client';

export const AnnouncementProduct = ({
  readerId,
  setNewLocalRead,
  setToggleShop,
  product,
  isOwned,
}) => {
  const handleTryAnnouncement = () => {
    // auth.currentUser.uid,

    setNewLocalRead(null);
    setNewLocalRead({
      userId: 'abc',
      name: 'You',
      book: 'Some book',
      theme: product.name,
      Timestamp: new Date(),
    });
    setToggleShop(false);
  };

  const handlePayment = () => {
    if (!readerId) {
      toast.error('No reader Id');
      return;
    }

    getDocument('demoReaders', readerId).then((res) => {
      if (!res.success) {
        toast.error('something went wrong');
        console.error(res);
        return;
      }

      const currentGold = res.data.stars || 0;
      const goldDeduction = res.data.starDeduction || 0;

      const balance = currentGold - goldDeduction;

      if (balance < product.price) {
        toast.error('No enough gold');
        return;
      }

      let readerData = { ...res.data };

      readerData.starDeduction = goldDeduction + product.price;
      let tempThemes = readerData?.themeInventory || [];

      tempThemes.push({
        name: product.name,
        src: product.src,
        type: 'announcement',
        purchasedAt: new Date(),
      });

      readerData['themeInventory'] = tempThemes;

      updateDocument(
        'demoReaders',
        readerId,
        readerData,
        auth.currentUser,
      ).then((res) => {
        if (!res.success) {
          toast.error('Something went wrong');
          return;
        }
        toast.success('Theme Purchased Successfully!');
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      });
    });
  };
  return (
    <div className='reading-announcement-product-container'>
      <ToastContainer />
      <img src={product.src} alt='' />
      <p>{product.name}</p>
      <button
        className='btn-try'
        onClick={() => {
          // handleTryAnnouncement();
          console.log({ product });

          const audio = new Audio(product.audio);
          audio.volume = 0.6;
          audio.play().catch((e) => console.log('Audio play failed:', e));
        }}>
        <FaPlay />
        Try
      </button>
      {isOwned ? (
        <p
          style={{
            color: '#ccc5',
            lineHeight: '40px',
          }}>
          Owned
        </p>
      ) : (
        <button
          className='btn-buy'
          onClick={() => {
            handlePayment();
          }}>
          <img
            src='https://firebasestorage.googleapis.com/v0/b/kids-az.appspot.com/o/public%2Fcoc-assets%2FIcon_HV_Resource_Gold_2.png?alt=media&token=b18097b0-407b-4668-88e1-fb7e4e2f3696'
            style={{
              height: '20px',
            }}
          />
          {product.price}
        </button>
      )}
    </div>
  );
};
